// removed by extract-text-webpack-plugin
module.exports = {"root":"styles__root__mzHqa","lastUpdated":"styles__lastUpdated__24zP4","indentedBullet":"styles__indentedBullet__HF7OX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SecurityRules/styles.css
// module id = 2254
// module chunks = 0